var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "loader",
    d: "M4 54C4 81.6142 26.3858 104 54 104C81.6142 104 104 81.6142 104 54C104 26.3858 81.6142 4 54 4",
    stroke: "url(#paint0_linear_56191_7481)",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56191_7481",
    x1: 6.25638,
    y1: 4,
    x2: 121.875,
    y2: 36.8699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498DD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#50D049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CBC434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C83DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#EC2C4C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.7731b143cc52c1908608b5056b9150cf.svg";
export { ForwardRef as ReactComponent };